

import api from "../utils/axios";

export async function getAddresses() {
    try {
        const response = await api.get(`/auth/userAddresses`);

        return response.data.addresses ?? [];

    } catch (error) {
        console.error("Failed to load addresses:", error);
        throw error;
    }
}


export async function getProvinces() {
    try {
        const response = await api.get(`/provinces`);

        return response.data.provinces ?? [];

    } catch (error) {
        console.error("Failed to load provinces:", error);
        throw error;
    }
}


export async function getCities(provinceId) {
    try {
        const response = await api.get(
            `/cities/${provinceId}`
        );

        return response.data.cities ?? [];

    } catch (error) {
        console.error("Failed to load cities:", error);
        throw error;
    }
}


export async function createAddress(addressData) {
    try {
        const response = await api.post(
            `/auth/createAddress`, 
            addressData
        );

        return response.data;

    } catch (error) {
        throw error;
    }
}


export async function deleteAddress(id) {
    try {
        const response = await api.delete(
            `/auth/userAddresses/${id}`
        );

        return response.data;

    } catch (error) {
        console.error("Delete address failed:", error);
        throw error;
    }
}
